import React from 'react';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import AddOnsCard from '../AddOnsCard';

import styles from './AddOnsList.Styles';

function AddOnsList({
  data,
  images,
  onItemPress,
  withStatusBadge,
  renderAddOnsCardFooter,
  showInActiveAddons,
  omitLongText,
  withCategories,
}) {
  const theme = useTheme();

  function renderAddOnsCard(item, index) {
    return (
      <AddOnsCard
        key={index}
        withStatusBadge={withStatusBadge}
        images={images}
        item={item}
        onPress={onItemPress.bind(this, item)}
        style={{ marginBottom: 20 }}
        renderAddOnsCardFooter={renderAddOnsCardFooter}
        omitLongText={omitLongText}
      />
    );
  }

  if (showInActiveAddons) {
    const activeAddons = [
      withCategories && (
        <VFText
          i18nKey={'manage_addon_active_addon_title'}
          style={styles.headerDescription(theme)}
        />
      ),
    ];
    const inactiveAddons = [
      <VFText
        i18nKey={'manage_addon_inactive_addon_title'}
        style={styles.headerDescription(theme)}
      />,
    ];

    data.map((item, index) =>
      item.status === 'active'
        ? activeAddons.push(renderAddOnsCard(item, index))
        : inactiveAddons.push(renderAddOnsCard(item, index)),
    );
    return (
      <>
        {activeAddons.length > 1 && activeAddons}
        {inactiveAddons.length > 1 && inactiveAddons}
      </>
    );
  } else {
    return data.map((item, index) => renderAddOnsCard(item, index));
  }
}

AddOnsList.defaultProps = {
  onPressItem: () => { },
  withStatusBadge: false,
};

AddOnsList.propTypes = {
  data: PropTypes.array,
  images: PropTypes.object,
  onItemPress: PropTypes.func,
  withStatusBadge: PropTypes.bool,
  renderAddOnsCardFooter: PropTypes.func,
  showInActiveAddons: PropTypes.bool,
  omitLongText: PropTypes.bool,
  withCategories: PropTypes.bool,
};
export default AddOnsList;
